import { FormikProps, getIn } from "formik";
import { CompanyReservationCode } from "../../../../model/CompanyReservationCode";
import { useEffect, useState } from "react";
import { B2bCompanyProduct } from "../../../../model/B2bCompany";
import { IconButton, Popover, TextField } from "@material-ui/core";
import FormReadonlyField from "../../../Common/FormReadOnlyField";
import React from "react";
import ReservationCodeSelector from "./ReservationCodeSelector";
import { ArrowDropDown } from "@material-ui/icons";

interface IProps extends FormikProps<B2bCompanyProduct> {
    selectableCodes: CompanyReservationCode[];
}

const ReservationCodeSelectorPopover = (props: IProps) => {
    const [anchorEl, setAnchorEl] = useState(null as HTMLInputElement);

    useEffect(() => {
        const { validateField } = props;
        validateField("codeHolderId");
    }, []);

    const handlePopupOpen = (e: any) => {
        setAnchorEl(e.currentTarget);
    };

    const handlePopupClose = () => {
        setAnchorEl(null);
    };

    const render = () => {
        const { selectableCodes, values, errors, setFieldValue } = props;

        if (!selectableCodes) {
            return (
                <FormReadonlyField {...props}
                    propName="codeHolderId"
                    label={`Reservation/Kod (${values.codeHolderId})`}
                    valueFormatter={() => "Kopplad mot en reservation/kod som inte längre är giltig"}
                >
                </FormReadonlyField>
            );
        }

        const isPopupOpen = Boolean(anchorEl);
        const matchedCode = selectableCodes.find(x => x.codeHolderId === values.codeHolderId);
        let safeLabel = "Reservation/Kod";
        let safeValue = "";
        if (!!matchedCode) {
            safeLabel = !!matchedCode.reservationName ? "Reservation" : "Kod";
            safeValue = matchedCode.reservationName ?? matchedCode.codeHolderName;
        } else if (!!values.codeHolderId) {
            safeLabel = `Reservation/Kod (${values.codeHolderId})`;
            safeValue = "Kopplad mot en reservation/kod som inte längre är giltig";
        }

        const endAdornment = (
            <IconButton
                style={{ padding: 0 }}
                onClick={handlePopupOpen}>
                <ArrowDropDown />
            </IconButton>
        );

        const errorFn = () => {
            return Boolean(
                getIn(errors, "codeHolderId")
            )
        };

        const helperFn = () => {
            return (
                getIn(errors, "codeHolderId")
            )
        };

        return (<>
            <TextField
                autoComplete="off"
                label={safeLabel}
                value={safeValue}
                fullWidth
                onClick={handlePopupOpen}
                InputLabelProps={{
                    shrink: true,
                }}
                InputProps={{
                    endAdornment: endAdornment
                }}
                inputProps={{ style: { cursor: "pointer" } }}
                error={errorFn()}
                helperText={helperFn()}
            />

            <Popover
                open={isPopupOpen}
                anchorEl={anchorEl}
                onClose={handlePopupClose}
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <ReservationCodeSelector
                    selectableCodes={selectableCodes}
                    productId={values.productId}
                    variantId={values.productVariantId}
                    initialValue={values.codeHolderId}
                    onChange={(value: string) => {
                        setFieldValue("codeHolderId", value);
                    }}
                />
            </Popover>
        </>);
    };

    return render();
};

export default ReservationCodeSelectorPopover;
